var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 135,
    viewBox: "0 0 149 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.856 114.279H0.0192871V37.7231H44.7121H79.7798H127.856V114.279Z",
    fill: "#D12626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128 37.723H0L46.4648 0H78.0273L128 37.723Z",
    fill: "#E96666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.159 9.15332H14.7166V95.6943H113.159V9.15332Z",
    fill: "#F8F8F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1856 30.7886H24.6995V34.3944H65.1856V30.7886Z",
    fill: "#E1E1E1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.563 39.6646H24.6995V41.6062H104.563V39.6646Z",
    fill: "#E1E1E1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M104.563 42.9927H24.6995V45.2117H104.563V42.9927Z",
    fill: "#E1E1E1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M104.563 46.5991H24.6995V48.5407H104.563V46.5991Z",
    fill: "#E1E1E1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104.563 49.9272H24.6995V52.1462H104.563V49.9272Z",
    fill: "#E1E1E1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M104.563 53.5332H24.6995V55.1974H104.563V53.5332Z",
    fill: "#E1E1E1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7734 57.1387H24.6995V59.3577H78.7734V57.1387Z",
    fill: "#E1E1E1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M127.856 114.278H0.0192871V37.7729L42.9679 82.4941L81.9039 82.9323L127.856 37.7729V114.278Z",
    fill: "#C0D7D6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M128 114.278H0L46.4648 76.2773H78.0273L128 114.278Z",
    fill: "#96B4B4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2425_21595)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.5 76C103.216 76 90 89.216 90 105.5C90 121.784 103.216 135 119.5 135C135.784 135 149 121.784 149 105.5C149 89.216 135.784 76 119.5 76Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2425_21595)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.5 76C103.216 76 90 89.216 90 105.5C90 121.784 103.216 135 119.5 135C135.784 135 149 121.784 149 105.5C149 89.216 135.784 76 119.5 76ZM113.6 120.25L98.85 105.5L103.009 101.341L113.6 111.902L135.991 89.511L140.15 93.7L113.6 120.25Z",
    fill: "#2C698D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2425_21595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    fill: "white",
    transform: "translate(90 76)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2425_21595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    fill: "white",
    transform: "translate(90 76)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailCheck);
export default __webpack_public_path__ + "static/media/emailCheck.b5f0790e57ca64887825886660300780.svg";
export { ForwardRef as ReactComponent };